import { BlogCard, MetaPill } from '@doist/marketist'

import { useLocale } from 'next-intl'

import css from './post-card.module.css'

import { PM_PATH } from '@/app/[locale]/productivity-methods/consts'
import { useTranslation } from '@/app/i18n/client'
import { type BlogIndexPost } from '@/app/services/contentful/schemas/contentful'
import { dynamicTranslate } from '@/services/productivity-methods/dynamic-translation'

type PostCardProps = {
    post: BlogIndexPost
    onCategoryClick?: (slug: string) => void
}

export function PostCard({ post, onCategoryClick }: PostCardProps) {
    const locale = useLocale()
    const { t: pmCommon } = useTranslation(locale, 'pm-common')

    function translate(text: string): string {
        return dynamicTranslate(text, pmCommon, locale)
    }

    return (
        <BlogCard
            title={translate(post.title)}
            href={`${PM_PATH}/${post.slug}`}
            src={`https:${post.thumbnailImage.file?.url}`}
            pills={post.tagList.map((tag) => (
                <MetaPill
                    className={css.category}
                    size="small"
                    key={tag.slug}
                    href={!onCategoryClick ? `${PM_PATH}/?category=${tag.slug}` : undefined}
                    onClick={
                        onCategoryClick
                            ? () => {
                                  onCategoryClick(tag.slug ?? 'all')
                              }
                            : undefined
                    }
                >
                    {tag ? translate(tag.name) : undefined}
                </MetaPill>
            ))}
            alt=""
        >
            {translate(post.description.slice(0, 100))}
        </BlogCard>
    )
}
